import Component from './TikTokAnalyticsPublicCampaign.vue'
export default Component
